import { PureComponent } from 'react'
import Attribution from '../attribution/attribution'
import styled from 'styled-components'
import Menu from './menu'
import MobileCTA from './cta'

const Container = styled.div``

const Row = styled.div`
    margin-left: 8px;
    text-align: left;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    display: flex;
`

type Props = {
    gif: any
    nextGif: any
    swipeProgress: number
}
class Primary extends PureComponent<Props> {
    render() {
        const {
            gif,
            gif: { user },
            nextGif,
            swipeProgress,
        } = this.props
        return (
            <Container>
                <Row>
                    <Attribution {...{ gif, nextGif, user, swipeProgress, nextUser: nextGif ? nextGif.user : null }} />
                    <Menu gif={gif} />
                </Row>
                <MobileCTA gif={gif} />
            </Container>
        )
    }
}

export default Primary
